module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAv0lEQVRIx2OQ7GKgEaJAczuDfC1OKclWCoxWzmAIs2AoCmDITGbwKmQoCmfQLWQIiGFICGXIdmew9WagyMu6OQyZgQx1zgxT/RiOZzOUOTFkWzDkuTBE+zKoVTBQHKadDPp5DK5xDLVeDOHmDG52DJollIc1EpJpYrBzZrAJo1Y0oqFWkA+oY3RtCMcuE14g2mLGyyrJAEEeQQwn6qGIfKOnunPdUxAAopvKAgww4OXK8L4WikaNHjV61OgRYDQA9tiXOpvP8h0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/zm.png
// module id = 417
// module chunks = 0